import * as React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const toDisplayText = (input) => {
  if (typeof input === "string" || typeof input === "number") return String(input);
  if (input && typeof input === "object") {
    if (typeof input.label === "string" && input.label.trim()) return input.label;
    if (typeof input.description === "string" && input.description.trim()) return input.description;
  }
  return "";
};

const listCell = (items = []) => {
  if (!items.length) return "None";
  const displayItems = items
    .map((item) => toDisplayText(item))
    .filter((item) => item.length > 0);
  if (!displayItems.length) return "None";
  return (
    <Box component="ul" sx={{ m: 0, pl: 2 }}>
      {displayItems.map((item, index) => (
        <li key={`${item}-${index}`}>{item}</li>
      ))}
    </Box>
  );
};

export default function BehaviorAssessmentHistoryTable({ title, rows = [], section }) {
  return (
    <Box sx={{ mt: 4 }}>
      <Box sx={{ backgroundColor: "#1F4B22", color: "white", py: 1.5, px: 2, textAlign: "center" }}>
        <Typography variant="h6">{title}</Typography>
      </Box>
      <Table size="small" sx={{ mt: 2 }}>
        <TableHead>
          <TableRow>
            <TableCell>Assessment date</TableCell>
            <TableCell>Behavior Category</TableCell>
            <TableCell align="right">Frequency %</TableCell>
            <TableCell>Specific Behaviors</TableCell>
            {section.hasDescription && <TableCell>Description</TableCell>}
            {section.hasLocation && <TableCell>Location</TableCell>}
            {section.hasAssociatedAnimals && <TableCell>Associated animals</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.key}>
              <TableCell>{row.assessmentDate}</TableCell>
              <TableCell>{row.behavior}</TableCell>
              <TableCell align="right">{row.frequencyPercent}</TableCell>
              <TableCell>{listCell(row.tags)}</TableCell>
            {section.hasDescription && <TableCell>{listCell(row.descriptions)}</TableCell>}
            {section.hasLocation && <TableCell>{listCell(row.locations)}</TableCell>}
            {section.hasAssociatedAnimals && <TableCell>{listCell(row.associatedAnimals)}</TableCell>}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}
